export default [
  {
      path: 'pyBreed',
      name: { list: ['产业大数据', '资源', '项目建设情况', '2060养殖情况'] },
      component: () => import('@/views/pyResources/pyBreed.vue')
  },
  {
      path: 'pyPasture',
      name: { list: ['产业大数据', '资源', '项目建设情况', '家庭牧场情况'] },
      component: () => import('@/views/pyResources/pyPasture.vue')
  },
  {
      path: 'pyIdle',
      name: { list: ['产业大数据', '资源', '项目建设情况', '闲散养殖点情况'] },
      component: () => import('@/views/pyResources/pyIdle.vue')
  },
  {
    path: 'pyBase',
    name: { list: ['产业大数据', '资源', '资源管理', '基础资源'] },
    component: () => import('@/views/pyResources/pyBase.vue')
  },
  {
    path: 'pyVariety',
    name: { list: ['产业大数据', '资源', '资源管理', '品种管理'] },
    component: () => import('@/views/pyResources/pyVariety.vue')
  },
  {
    path: 'pyDistrib',
    name: { list: ['产业大数据', '资源', '资源管理', '品种分布'] },
    component: () => import('@/views/pyResources/pyDistrib.vue')
  },
  {
    path: 'pyDistribEdit',
    name: { list: ['产业大数据', '资源', '资源管理', '品种分布'] },
    component: () => import('@/views/pyResources/pyDistribEdit.vue')
  },
  {
    path: 'pyPrice',
    name: { list: ['产业大数据', '资源', '资源管理', '产地价格指数'] },
    component: () => import('@/views/pyResources/pyPrice.vue')
  },
]